
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-in/[page]",
      function () {
        return require("private-next-pages/new-in/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-in/[page]"])
      });
    }
  